var router = require('pjax').Router;
var index = require('./index.js');
var progress = require('./progress.js');

router.get('judging/leaderboard', index);
router.get('judging/progress', progress);
